export function SaveArticle() {
    $("#btnArticleDelete").attr("disabled", true);
    $("#btnArticleSave").attr("disabled", true);
    $(".articles.loadingContainer").show();

    var category = $("#CategoryDropdown option:selected").text();
    if (category == "Please Select") {
        alert("You must select a valid category");
        return;
    }

    //var editorhtml = editor.html.get();
    var editor = $("#froala-editor");
    var editorhtml = editor[0]['data-froala.editor'].html.get();
    var articleText = $("<textarea/>").html(editorhtml).text();
    var TitleEdited = $("#TitleTextBox").val();
    var articleId = $("#articleId").val();
    var isHidden = $('#cbxIsHidden').is(":checked");

    var appliedTags = "";
    $(".edit-applied-tags button").each(function (index, button) {
        appliedTags += $(button).attr("id") + ",";
    });
    //remove the last comma
    if (appliedTags.trim() != "") {
        appliedTags = appliedTags.substr(0, appliedTags.length - 1);
    }

    var categories = [];
    $(".edit-categories button").each(function (index, button) {
        var id = $(button).attr("id");
        categories.push(id);
    });
    $.ajax({
        url: articleBaseUrl() + "/AlliedPilots/Articles/SaveArticle",
        type: "POST",
        data: {
            PageText: encodeURI(articleText),
            ArticleID: articleId,
            Title: TitleEdited,
            CategoryIds: categories,
            SearchTags: appliedTags,
            IsHidden: isHidden
        },
        dataType: "text",
        success: function (response) {
        $(".articles.loadingContainer").hide();

        if (response.toLowerCase() == "false") {
            $("#btnArticleDelete").removeAttr("disabled");
            $("#btnArticleSave").removeAttr("disabled");
            alert(
            "There was a problem saving the article. Copy your changes and try refreshing to re-input the content"
            );
        } else {
            if (articleId == "0" || articleId == "-1") {
            alert("Created Successfully");
            window.location.href = "/News";
            } else {
            alert("Updated Successfully");
            window.location.href =
                "/Services/View-FullArticle?ArticleId=" + articleId;
            }
        }
        },
        error: function (response) {
        $(".articles.loadingContainer").hide();
        $("#btnArticleDelete").removeAttr("disabled");
        $("#btnArticleSave").removeAttr("disabled");

        alert(
            "There was a problem saving the article. Copy your changes and try refreshing to re-input the content"
        );
        },
    });
}

export function SelectCategory(control) {
  var id = control.find("option:selected").val();
  if (id != "") {
    var name = control.find("option:selected").html();
    var container = $("#categories-container");

    var newBtnHtml =
      '<button class="btn btn-sm btn-primary" id="' +
      id +
      '">' +
      name +
      ' <span class="btn btn-sm btn-danger sub-btn" onclick="EntryPoint.EditArticle.RemoveCategoryFromSelected($(this))">X</span></button>';
    container.append(newBtnHtml);

    control.val("");
  }
}

export function RemoveCategoryFromSelected(control) {
  var btn = control.parents("button");
  btn.remove();
}

export function MoveToApplied(control) {
  var tag = control.parents("button");
  if (tag.attr("id") != "undefined") {
    tag.html(
      tag.attr("id") +
        " <span class='btn btn-sm btn-danger sub-btn' onclick='EntryPoint.EditArticle.RemoveFromApplied($(this))'>X</span>"
    );
    $(".edit-applied-tags").append(tag);
  } else {
    tag.remove();
    alert("Invalid Tag");
  }
  //$('.available-tags').append("<button class='btn btn-primary' id='" + TagName + "' >" + TagName + "<span class='btn btn-sm btn-danger sub-btn' onclick='EntryPoint.EditArticle.RemoveFromApplied(" + TagName + ")'>X</span></button>");
  //$('.applied-tags').append("<button class='btn btn-primary' id='" + TagName + "' >" + TagName + "<span class='btn btn-sm btn-danger sub-btn' onclick='EntryPoint.EditArticle.RemoveFromApplied($(this));'>X</span></button>");
}

export function RemoveFromApplied(control) {
  var tag = control.parents("button");
  if (tag.attr("id") != "undefined") {
    tag.html(
      tag.attr("id") +
        " <span class='btn btn-sm btn-warning sub-btn' onclick='EntryPoint.EditArticle.MoveToApplied($(this))'>+</span>"
    );
    $(".edit-available-tags").append(tag);
  } else {
    tag.remove();
    alert("Invalid Tag");
  }
}

export function DeleteArticle(articleID) {
  $("#btnArticleSave").attr("disable", true);
  $("#btnArticleDelete").attr("disable", true);
  $(".articles.loadingContainer").show();

  var r = confirm("Are you sure you want to delete the selected article?");
  if (r === true) {
    $.ajax({
      url: articleBaseUrl() + "/AlliedPilots/Articles/DeleteArticle",
      data: { articleId: articleID },
      type: "POST",
      success: function (response) {
        $(".articles.loadingContainer").hide();
        if (response.toLowerCase() == "false") {
          $("#btnArticleSave").removeAttr("disabled");
          $("#btnArticleDelete").removeAttr("disabled");
          alert(
            "There was a problem deleting the article. Refresh the page if you would like to try again."
          );
        } else {
          alert("Deleted Successfully");
          window.location.href = "/News";
        }
      },
      error: function (response) {
        $(".articles.loadingContainer").hide();
        $("#btnArticleSave").removeAttr("disabled");
        $("#btnArticleDelete").removeAttr("disabled");

        alert(
          "There was a problem deleting the article. Refresh the page if you would like to try again."
        );
      },
    });
  }
}

function articleBaseUrl() {
  return window.location.protocol + "//" + window.location.host;
}articleBaseUrl
